import * as moment from 'moment';

export default {
    data() {
        return {
            maxFileSize: 100,
            maxFileUnitStr: 'MB',
        }
    },
    methods: {
        //检查文件类型
        checkFileType: function (fileType) {
            const acceptTypes = [
                "txt", "png", "PDF", "TXT", "WPS", "wps", "WPT", "wpt",
                "xls", "xlsx", "XLS", "XLSX",
                "doc", "docx", "DOC", "DOCX",
                "ppt", "pptx", "pps", "PPT", "PPTX", "PPS",
                "jpg", "jpeg", "JPG", "JPEG", "pdf", "PNG",
                "m4a", "M4A", "mp4", "MP4",
                "rar", "zip", "7z"
            ];
            for (let i = 0 ; i < acceptTypes.length ; i++) {
                if (fileType === acceptTypes[i]) {
                    return true;
                }
            }
            return false;
        },
        //检查文件大小
        checkFileSize: function (fileSize, businessModuleCode) {
            //20M
            let fileSizeToBytes = 100 * 1024 * 1024;
            if (businessModuleCode) {
                const vos = JSON.parse(localStorage["maxFileSettings"]);
                const moduleVo = vos.find(vo => vo.code === businessModuleCode);
                if (moduleVo && moduleVo.maxFileSizeToBytes) {
                    fileSizeToBytes = moduleVo.maxFileSizeToBytes
                    this.maxFileSize = moduleVo.maxFileSize
                    this.maxFileUnitStr = moduleVo.maxFileUnitStr
                }
            }
            return fileSize <= fileSizeToBytes;

        },
        getAlertStr(uploadStatus) {
            const alertStr = this.$t("label.em.components.emAttachment.uploadStatus." + uploadStatus);
            if (uploadStatus !== -3) {
                return alertStr
            }
            return alertStr + this.maxFileSize + this.maxFileUnitStr;
        },
        downloadFile: function (data, type, fileName, ext) {
            let blob = new Blob([data], {
                type: `${type};charset-UTF-8`
            });
            let objectURL = URL.createObjectURL(blob);
            let downEle = document.createElement('a');
            downEle.href = objectURL;
            const currentTime = moment().format('YYYY-MM-DD_HH-mm');
            downEle.setAttribute('download', fileName + currentTime + ext);
            downEle.click();
        }
    }
}
